import { Component } from 'vue-property-decorator';
import IssueItemBaseMixin from '@/components/ViewComponent/Issue/IssueItem/issue-item-base.mixin';
import { StaffEntity } from '@/entities/staff.entity';
import { CSelectButtonsPropsItems } from '@/components/Helper/Form/CSelectButtons.vue';
import { mapState } from 'vuex';
import IssueService, { SendThankIssueEntity } from '@/services/issue.service';
import { UseService } from '@/services/service';

@Component<BtnSendThankMixin>({
  computed: {
    ...mapState('staff', ['current']),
  },
})
export default class BtnSendThankMixin extends IssueItemBaseMixin {
  dialog = false;

  @UseService(IssueService)
  service: IssueService;

  current!: StaffEntity;

  resolveData: SendThankIssueEntity = {
    issueId: null,
    supporterId: null,
    gift: 0,
    message: null,
  };

  created() {
    this.resolveData.issueId = this.issue.id;
  }

  get pointOptionList(): CSelectButtonsPropsItems[] {
    return this.current.defaultGiftPoint.map((pt) => ({
      value: pt,
      text: `${pt}pt`,
    }));
  }

  async resolve() {
    await this.service.sendThank(this.resolveData);
    this.dialog = false;
  }
}
